<app-header></app-header>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>

<div class="dta_title mar-tb-20  pad-lr-15 col-md-12">{{'Export Past/Future Deliveries' | translate}}
  <span style="float:right;font-size:16px;"><a href="#/poDashboard">{{'PO Dashboard' | translate}}&nbsp;<i class="fa fa-reply"
        aria-hidden="true"></i></a></span>
</div>
<section>
  <div class="exports1">
    <div class="dta_title mar-tb-20  pad-lr-15 col-md-6">{{'Future Deliveries' | translate}}
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <label>{{'Year' | translate}}</label>
          <input class="form-control" [(ngModel)]="exportTwodata.year" disabled>
        </div>
        <div class="col-md-3">
          <label>{{'Month' | translate}}</label>
          <input class="form-control" [(ngModel)]="exportTwodata.month" disabled>
        </div>
        <div class="col-md-3">
          <label>{{'Day' | translate}}</label>
          <input class="form-control" [(ngModel)]="exportTwodata.day" disabled>
        </div>
        <div class="col-md-3 mar-top-30">
          <button class="btn btn-dark" (click)="export2Download()">
            <i class="fa fa-download"></i>&nbsp;&nbsp;{{'Export' | translate}}
          </button>
        </div>
      </div>
    </div>
    <small style="margin:120px; color: #9DADD3">**{{'This Export only contains future delivery dates. The values are based on actual purchase orders and forecasts' | translate}}.</small>
  </div>
</section>
<section class="exports2">
  <div class="dta_title mar-tb-20 pad-lr-15 col-md-6">{{'Past Deliveries' | translate}}</div>
  <div class="container">
    <p-table [value]="exportOneData" [responsive]="true" [rows]="12" [paginator]="true" [pageLinks]="3">
      <!-- <p-column styleClass="text-center" field="year" header="{{'Year' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="{{'Search Year' | translate}}"></p-column>
      <p-column styleClass="text-center" field="month" header="{{'Month' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="{{'Search Month' | translate}}"></p-column>
      <p-column styleClass="text-center" field="action" header="{{'ACTION' | translate}}">
        <ng-template let-row="rowData" pTemplate="body">
          <button class="btn btn-dark" (click)="downloadFile(row.blobUrl)">
            <i class="fa fa-download" aria-hidden="true"></i>&nbsp;&nbsp;{{'Export' | translate}}
          </button>
        </ng-template>
      </p-column> -->
      <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="year" style="width:20%">{{'Year' | translate}} <p-sortIcon field="year"></p-sortIcon></th>
            <th pSortableColumn="month" style="width:20%">{{'Month' | translate}} <p-sortIcon field="month"></p-sortIcon></th>
            <th style="width:20%">{{'ACTION' | translate}}</th>

        </tr>
        <tr>
          <th>
            <p-columnFilter type="text" field="year"></p-columnFilter>
        </th>
        <th>
          <p-columnFilter type="text" field="month"></p-columnFilter>
         </th>
         <th>
        </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-value>
        <tr>
            <td>{{value.year}}</td>
            <td>{{value.month}}</td>
            <td> <button class="btn btn-dark" (click)="downloadFile(row.blobUrl)">
              <i class="fa fa-download" aria-hidden="true"></i>&nbsp;&nbsp;{{'Export' | translate}}
            </button></td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">

      <tr>

        <td>{{'No Records Found' | translate}}</td>

      </tr>

    </ng-template>
    </p-table>
  </div>

</section>